module.exports = __webpack_public_path__ + "img/round-arrow_back-24px.5ae60ad5.svg";